<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="modalTitle" :modal-id="idModal" @close="back">
            <template v-slot:modal-body>
                <div class="p-x-4 f-regular f-c-black f-16">
                    <div>
                        <p v-if="isActive">
                            Jika mesin EDC nonaktif, kasir tidak dapat membuat pembayaran dengan mesin EDC ini sampai
                            mesin diaktifkan kembali. Anda tetap dapat membuat settlement, dan melakukan perubahan data
                            mesin.
                        </p>
                        <p class="m-d-0">
                            Yakin ingin {{ bodyText }} mesin
                            <span class="text-promo">{{ detailMesin.nama_mesin_edc }}</span
                            >?
                        </p>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <SOButton
                        :outline="isActive"
                        :primary="!isActive"
                        :text="getBtnText"
                        :full="true"
                        :disable="isFetching"
                        :loading="isFetching"
                        :id="`btn-switch-mesin`"
                        @action="switchMesin"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
    name: "ModalSwitchMesin",
    components: {
        SOSlotModal,
        SOButton,
    },
    data() {
        return {
            idModal: `modal-switch-mesin`,
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.idModal}`).modal("show");
        this.setPosted(this.detailMesin);
    },
    computed: {
        ...mapGetters(moduleName, {
            detailMesin: "detailMesin",
            posted: "posted",
            isFetching: "isFetching",
        }),
        isActive() {
            return this.detailMesin.active ? true : false;
        },
        getBtnText() {
            return this.isActive ? "Ya, Nonaktifkan" : "Ya, Aktifkan";
        },
        bodyText() {
            return this.isActive ? "menonaktifkan" : "kembali mengaktifkan";
        },
        modalTitle() {
            return this.isActive ? "Nonaktifkan Mesin EDC" : "Aktifkan Mesin EDC";
        },
    },
    methods: {
        ...mapActions({
            saveMesinEdc: `${moduleName}/saveMesinEdc`,
            resetListMesin: `${moduleName}/resetListMesin`,
            resetDetailMesin: `${moduleName}/resetDetailMesin`,
            setFetching: `${moduleName}/setFetching`,
            setPosted: `${moduleName}/setPosted`,
        }),
        back() {
            this.$router.push({ name: "mesin.edc.detail" });
        },
        closeModal() {
            $(`#${this.idModal}`).modal("hide");
        },
        gotoDetail(mesin) {
            this.$router.push({ name: "mesin.edc.detail" });
        },
        switchMesin() {
            let posted = { ...this.posted, idedc: this.$route.params.id_mesin, active: this.isActive ? 0 : 1 };
            let saving = this.saveMesinEdc(posted);

            saving
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200) {
                        if (status) {
                            this.$toast.success(msg);
                            this.resetListMesin();
                            this.resetDetailMesin();
                            this.gotoDetail(data);
                        } else {
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
    },
};
</script>
